// import { NavLink } from "react-router-dom";
import scheduleImage from "@/images/schedule_image.jpg";
import schedulePractice from "@/images/schedule_practice.png";
import scheduleGames from "@/images/schedule_games.png";
import { Logo } from "@/components/lib";

export default function Schedule() {
  return (
    <main className="flex flex-col text-center text-white">
      <Logo className="w-48 lg:w-64 mx-auto my-5 sm:mt-0 lg:hidden" />
      <div className="hidden sm:block relative w-full overflow-hidden shadow-lg pb-4">
        <img
          src={scheduleImage}
          alt="Grapevine High School"
          className="w-full h-[70vh] lg:h-[90vh] opacity-20"
        />

        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(180deg, rgba(7, 16, 27, 0) 18.3%, #07101B 100%)"
          }}
        />

        <div className="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 p-2 text-white w-full">
          <div className="flex justify-center items-center gap-8">
            <img
              src={schedulePractice}
              alt="Grapevine High School"
              className="w-1/3"
            />
            <img
              src={scheduleGames}
              alt="Grapevine High School"
              className="w-1/3"
            />
          </div>

          {/* <div className="text-2xl mt-10 lg:text-5xl flex justify-center items-center gap-2 lg:gap-8">
            <NavLink
              to="/schedule/spring"
              className="bg-[#CF2027] px-2 py-2 lg:px-6 lg:py-3 h-fit rounded-full text-lg lg:text-xl w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5"
            >
              View Spring Schedule
            </NavLink>
            <NavLink
              to="/schedule/fall"
              className="bg-[#CF2027] px-2 py-2 lg:px-6 lg:py-3 h-fit rounded-full text-lg lg:text-xl w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5"
            >
              View Fall Schedule
            </NavLink>
          </div> */}
        </div>
      </div>

      <div className="sm:hidden flex flex-col justify-center items-center gap-8 pb-8">
        <img
          src={schedulePractice}
          alt="Grapevine High School"
          className="w-2/3"
        />
        <img src={scheduleGames} alt="Grapevine High School" className="w-2/3" />
      </div>
    </main>
  );
}
